module.exports = __webpack_public_path__ + "static/media/arrow-down-fill.5c1265fd.svg";